// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { useContext } from "react";

import { IntercomContext } from "./IntercomContext";

export const useIntercom = () => useContext(IntercomContext);
